import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import styled from '@emotion/styled';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

import { SecondaryButton } from '../button';
import { Small } from '../type';
import { COLORS, FONT_SIZE, GLOBAL, SPACE } from '../../constants';

const StyledFormControl = styled(FormControl)`
  &.MuiFormControl-root {
    margin-bottom: ${(props) => (props.fullWidth ? SPACE.X2 : SPACE.X1)};
    margin-right: ${(props) => !props.fullWidth && SPACE.X1};
  }
  & label + .MuiInput-formControl {
    margin-top: 0;
  }
`;

const StyledInputLabel = styled(InputLabel)`
  &.MuiInputLabel-formControl {
    color: ${COLORS.GREY_ELEVEN};
    font-family: ${GLOBAL.BRAND_FONT_FAMILY_SECOND};
    font-size: ${FONT_SIZE.MEDIUM};
    line-height: 16px;
    margin-bottom: ${SPACE.X1};
    text-transform: uppercase;
    position: static;
    transform: none;
  }
  &.MuiInputLabel-formControl.Mui-focused {
    color: unset;
  }
`;

const StyledSecondaryButton = styled(SecondaryButton)`
  text-align: left;

  &.MuiButtonBase-root {
    line-height: 22px;
    padding: ${SPACE.X1};
    text-align: right;
  }

  & .MuiButton-label {
    display: inline-flex;
    justify-content: flex-start;
  }

  & .MuiButton-endIcon {
    margin-left: auto;

    & > * {
      font-family: ${GLOBAL.BRAND_FONT_FAMILY};
      font-size: ${FONT_SIZE.MEDIUM} !important;
      color: ${COLORS.BRAND_BLUE_NINE};
    }
  }
`;

const StyledButtonContent = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ${GLOBAL.BRAND_FONT_FAMILY};
  font-size: ${FONT_SIZE.MEDIUM};
  padding-right: ${SPACE.X1};
`;

const StyledSecondaryButtonContent = styled(Small)`
  width: max-content;
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'label' implicitly has an 'any' type.
const VariantButton = ({ label, children, onClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <StyledFormControl fullWidth>
      <StyledInputLabel disableAnimation shrink={false}>
        {label}
      </StyledInputLabel>
      <StyledSecondaryButton
        type="button"
        onClick={onClick}
        endIcon={<StyledSecondaryButtonContent>{isMobile ? 'Change' : 'Change variant'}</StyledSecondaryButtonContent>}
      >
        <StyledButtonContent>{children}</StyledButtonContent>
      </StyledSecondaryButton>
    </StyledFormControl>
  );
};

export default VariantButton;
